// extracted by mini-css-extract-plugin
export default {"nearfoot":"CaroselAll_nearfoot__H3L47","pname":"CaroselAll_pname__BvIQ1","heading_to_nearfoot":"CaroselAll_heading_to_nearfoot__acFKX"};